type BackendErrorResponse = {
  error?: {
    code?: string;
    message?: string;
  };
  message?: string;
};

type ApiError = {
  response?: {
    data?: BackendErrorResponse;
  };
};

export const getApiErrorMessage = (error: unknown, fallback: string) => {
  const responseData = (error as ApiError)?.response?.data;
  return responseData?.error?.message || responseData?.message || fallback;
};

/**
 * The API's machine-readable code, when it sent one.
 *
 * Distinct from the message beside it: the message is prose that may be
 * reworded at any time, while the code is the contract a client is allowed to
 * branch on — which is what telling `SESSION_SUPERSEDED` apart from an ordinary
 * expiry requires.
 */
export const getApiErrorCode = (error: unknown): string | null =>
  (error as ApiError)?.response?.data?.error?.code ?? null;

const AUTH_ERROR_KEYS: Record<string, string> = {
  INVALID_CREDENTIALS: "auth_error_invalid_credentials",
  INVALID_REFERRAL_CODE: "validation_referral_invalid",
  USERNAME_TAKEN: "auth_error_username_taken",
  ACCOUNT_PENDING_REVIEW: "auth_error_pending_review",
  ACCOUNT_BANNED: "auth_error_banned",
  ACCOUNT_REJECTED: "auth_error_rejected",
  RATE_LIMITED: "auth_error_rate_limited",
  VALIDATION_FAILED: "auth_error_invalid_request",
};

export const getAuthErrorMessage = (
  error: unknown,
  translate: (key: string) => string,
  fallbackKey: string
) => translate(AUTH_ERROR_KEYS[getApiErrorCode(error) ?? ""] ?? fallbackKey);
